
import { Vue } from 'vue-property-decorator';
export default class ToolbarItem extends Vue {}
